import React from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { EMPTY_TOKEN, LOGIN_AUTO_ERR, LOGIN_AUTO_EXCEPTION } from "../../constants/errMessage";
import { useLoading } from '../../utils/spinner';
import { loginTokenAuth } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { SCREEN_ROUTER } from "../../constants/screenRouter";
import { removeLocalStorage, setLocalStorage } from "../../utils/localStorage";
import { STORAGE_KEY } from "../../constants/storageKeys";
import nextScreen from "../../utils/navigateScreen";
import ReactPlayer from "react-player";
import { YOUTUBE_URL_MANUAL } from "../../constants/Common";

const Login = () => {
    const [inputToken, setInputToken] = useState('');
    const [errorMessage, setErrorMessage] = useState(""); // Trạng thái để lưu lỗi
    const { loading, setLoading } = useLoading();
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!inputToken) {
            //console.log("Token is required");
            setErrorMessage(EMPTY_TOKEN);
            return;
        }
        setLoading(true);
        setLocalStorage(STORAGE_KEY.LOGIN_TOKEN, { token: inputToken })
        loginTokenAuth().then((resolve) => {
            if (resolve.error === false) {
                setErrorMessage('');
                //console.log('login token success', resolve.data);
                navigate(SCREEN_ROUTER.LOGIN_METHOD);
            } else {
                setErrorMessage(LOGIN_AUTO_ERR);
                removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
                //console.log('login token error', resolve);
            }
        }).catch((err) => {
            setErrorMessage(LOGIN_AUTO_EXCEPTION);
            removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
            //console.log('login token exception', err);
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        navigate(nextScreen(SCREEN_ROUTER.LOGIN_TOKEN));
    }, []);

    return (
        <Container className="mt-3 d-flex justify-content-center flex-column">
            <Row className="w-100">
                <Col xs={12} md={8} lg={6} className="mx-auto">
                    <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
                        {/* Header */}
                        <div className="h4 mb-2 text-center">Nhập Code</div>

                        {/* Hiển thị lỗi */}
                        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                        <Form.Group className="mb-2" controlId="token">
                            <Form.Control
                                type="text"
                                value={inputToken}
                                placeholder="Nhập code"
                                onChange={(e) => setInputToken(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Button className="mx-auto" variant="primary" disabled={!inputToken} type="submit">
                            Kiểm tra
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className="pt-3 justify-content-center">
                <Col sm = {12} xs={12} md={8} lg={7}>
                    <div className="text-success text-start">Hãy liên hệ zalo
                        <a href="https://zalo.me/0819000989" target="_blank" className="ms-1 me-1">0819000989</a>
                        để sử dụng <span className="text-primary font-weight-bold">MIỄN PHÍ</span> nhé ngoài sự kiện Ngọa Long Chương</div>
                    <div className="text-success"></div>
                    <ol className="text-start">
                        <li>Auto tham gia/Tạo quân đoàn</li>
                        <li>Auto farm hải sản giờ reset</li>
                        <li>Auto Quốc chiến ...</li>
                    </ol>
                </Col>
            </Row>
            <Row>
                {/* Hàng chứa video */}
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <ReactPlayer url={YOUTUBE_URL_MANUAL} controls={true} width="100%" />
                    </Col>
                </Row>
            </Row>
        </Container>
    );
}

export default Login;
